import { faFileArchive, faFileText } from "@fortawesome/free-regular-svg-icons";
import {
  faBasketShopping,
  faBookBookmark,
  faDashboard,
  faLayerGroup,
  faStore,
  faUsers,
  faEnvelope,
  faRotateLeft,
  faChartLine,
  faUpload,
  faCircleQuestion,
  faFileInvoiceDollar,
  faFileInvoice,
  faStar,
  faComments,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import useRole from "../hook/useRole";
import InfoIcon from "./InfoIcon";

const SidebarLink = ({ to, icon, children, onNavigate }) => (
  <NavLink
    className={({ isActive }) =>
      `sidebar-link btn btn-outline-secondary${isActive ? " active" : ""}`
    }
    to={to}
    end={to === "/"}
    onClick={onNavigate}
  >
    <InfoIcon size="lg" title={children} icon={icon} />
    <span className="sidebar-label">{children}</span>
  </NavLink>
);

const AdminSidebar = ({ onNavigate }) => {
  const { hasrole } = useRole("rsosuperuser");

  return (
    <>
      <SidebarLink to="/" icon={faDashboard} onNavigate={onNavigate}>Dashboard</SidebarLink>
      <SidebarLink to="/admin/users" icon={faUsers} onNavigate={onNavigate}>Users</SidebarLink>
      <SidebarLink to="/admin/mail" icon={faEnvelope} onNavigate={onNavigate}>E-Mails</SidebarLink>
      <SidebarLink to="/admin/reviews" icon={faStar} onNavigate={onNavigate}>Bewertungen</SidebarLink>
      <SidebarLink to="/admin/refund-requests" icon={faRotateLeft} onNavigate={onNavigate}>Refund requests</SidebarLink>
      <SidebarLink to="/admin/products" icon={faStore} onNavigate={onNavigate}>Products</SidebarLink>
      <SidebarLink to="/admin/producttypes" icon={faLayerGroup} onNavigate={onNavigate}>Types</SidebarLink>
      {hasrole && <SidebarLink to="/admin/logs" icon={faFileText} onNavigate={onNavigate}>Logs</SidebarLink>}
      <SidebarLink to="/admin/files" icon={faFileArchive} onNavigate={onNavigate}>Files</SidebarLink>
      {hasrole && <SidebarLink to="/admin/pdc" icon={faChartLine} onNavigate={onNavigate}>PDC</SidebarLink>}
      {hasrole && <SidebarLink to="/admin/invoices" icon={faFileInvoiceDollar} onNavigate={onNavigate}>Rechnungen</SidebarLink>}
      {hasrole && <SidebarLink to="/admin/timesheets" icon={faFileInvoice} onNavigate={onNavigate}>Zeitnachweise</SidebarLink>}
      <SidebarLink to="/admin/instagram" icon={faUsers} onNavigate={onNavigate}>Instagram</SidebarLink>
      <SidebarLink to="/admin/uploadmanagement" icon={faUpload} onNavigate={onNavigate}>Uploads</SidebarLink>
      <SidebarLink to="/admin/faqs" icon={faCircleQuestion} onNavigate={onNavigate}>FAQs</SidebarLink>
      <SidebarLink to="/admin/chat" icon={faComments} onNavigate={onNavigate}>Chat</SidebarLink>
    </>
  );
};

const UserSidebar = ({ onNavigate }) => (
  <>
    <SidebarLink to="/" icon={faDashboard} onNavigate={onNavigate}>Dashboard</SidebarLink>
    <SidebarLink to="/orders" icon={faBasketShopping} onNavigate={onNavigate}>Orders</SidebarLink>
    <SidebarLink to="/products" icon={faStore} onNavigate={onNavigate}>Products</SidebarLink>
    <SidebarLink to="/favorites" icon={faBookBookmark} onNavigate={onNavigate}>Favorites</SidebarLink>
  </>
);

export default function Sidebar({ isOpen = false, onClose }) {
  const isAdmin = useSelector((state) => state.user.isAdmin);
  return (
    <aside id="app-sidebar" className={`sidebar${isOpen ? " sidebar-open" : ""}`} aria-label={isAdmin ? "Admin navigation" : "User navigation"}>
      <div className="sidebar-mobile-header">
        <strong>Navigation</strong>
        <button type="button" onClick={onClose} aria-label="Close navigation">
          <InfoIcon icon={faXmark} />
        </button>
      </div>
      {isAdmin ? <AdminSidebar onNavigate={onClose} /> : <UserSidebar onNavigate={onClose} />}
    </aside>
  );
}
